var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormWrapper',{attrs:{"is-loading":_vm.isLoading}},[_c('PageTitle',{attrs:{"slot":"title","title":"View Salary Fixation","link":"/helpContent/viewSalaryFixation"},slot:"title"}),_c('salary',{attrs:{"form":_vm.form}}),_c('ButtonGroup',[_c('FormButton',{attrs:{"type":"info"},on:{"click":()=>{_vm.$router.go(-1)}}},[_vm._v("Back")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }